"use client"

import { router } from "@inertiajs/react"

import { Table, TableCard } from "@/components/ui/table"
import { CopyLinkButton } from "@/components/warm-starts/copy-link-button"
import { WarmStartStatusBadge } from "@/components/warm-starts/status-badge"
import { formatDate } from "@/lib/utils/"
import { editAdminWarmStartPath } from "@/routes"
import type { WarmStartLedgerRow } from "@/types"

interface WarmStartLedgerTableProps {
  rows: WarmStartLedgerRow[]
  "aria-label"?: string
}

// The warm-start ledger table. Shared verbatim by the admin index and the
// dashboard growth band so the two surfaces stay in lockstep — they differ only
// in the rows the controller feeds in.
export function WarmStartLedgerTable({
  rows,
  "aria-label": ariaLabel = "Invites",
}: WarmStartLedgerTableProps) {
  return (
    <TableCard.Root>
      <Table aria-label={ariaLabel} className="bg-primary">
        <Table.Header>
          <Table.Head
            id="recipient"
            isRowHeader
            label="Recipient"
            className="w-full"
          />
          <Table.Head id="status" label="Status" />
          <Table.Head id="created" label="Created" />
          <Table.Head id="actions" />
        </Table.Header>
        <Table.Body items={rows}>
          {(row: WarmStartLedgerRow) => (
            // The whole row opens the draft's coordinator editor (react-aria
            // excludes the Copy button's press).
            <Table.Row
              id={row.id}
              className="cursor-pointer"
              onAction={() => router.visit(editAdminWarmStartPath(row.id))}
            >
              <Table.Cell>
                <div>
                  <p className="text-primary text-sm font-medium whitespace-nowrap">
                    {row.recipient_name}
                  </p>
                  <p className="text-tertiary text-sm whitespace-nowrap">
                    {row.recipient_email}
                  </p>
                </div>
              </Table.Cell>
              <Table.Cell>
                <WarmStartStatusBadge status={row.status} />
              </Table.Cell>
              <Table.Cell className="text-tertiary whitespace-nowrap">
                {formatDate(row.created_at)}
              </Table.Cell>
              <Table.Cell className="px-4">
                <div className="flex justify-end">
                  <CopyLinkButton url={row.claim_url} />
                </div>
              </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </TableCard.Root>
  )
}
